import React from 'react';
export function ProductShowcase() {
  const row1Colors = ['bg-blue-900', 'bg-slate-600', 'bg-sky-700', 'bg-slate-800', 'bg-slate-500', 'bg-blue-800'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-218">
      <div className="max-w-5xl mx-auto text-center" data-id="element-219">
        <div data-id="element-220">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-221">
            <span className="text-xl" data-id="element-222">🏒</span> ICE HOCKEY READY
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-brand-accent" data-id="element-223">
            The Ultimate Pro Bundle
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-224">
            <p className="text-xl md:text-2xl text-white font-bold" data-id="element-225">
              6 volumes organized by technical goals and season blocks.
            </p>
            <p className="text-base md:text-lg text-white/70 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-226">
              120+ high-intensity modules. 6 strategic bonuses. Ready to deploy.
            </p>
          </div>
        </div>

        {/* Grid Showcase */}
        <div className="relative max-w-3xl mx-auto mb-16" data-id="element-227">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3 mb-6" data-id="element-228">
            {row1Colors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-brand-accent rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-229">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-230">
                  {i + 1}°
                </span>
              </div>)}
          </div>

          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-brand-accent text-brand-accent px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-231">
            6 PROFESSIONALLY STRUCTURED VOLUMES
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto mt-12" data-id="element-232">
          {['✅ Aligned with Global Pro Standards (USA Hockey / Hockey Canada)', '✅ High-impact technical correction cues', '✅ Built-in player assessment tools', '✅ Scalable for any roster size'].map((item, i) => <div key={i} className="bg-brand-card border border-brand-accent px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-233">
              <span className="font-medium text-white/90 text-sm md:text-base" data-id="element-234">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}